var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v("改变")]),_c('h2',{staticClass:"subtitle"},[_vm._v("Difference ("+_vm._s(_vm.diff.length)+")")]),_vm._l((_vm.diff),function([file, status]){return _c('change',{key:`diff_${file}`,attrs:{"file":file,"status":status,"noReset":_vm.noReset,"issue":_vm.issue}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }